<template>
    <div class="card-container">
        <div class="current-user-email">
            {{ currentUser.email }}
        </div>
        <el-card
            shadow="never"
            class="total-card card-container__card"
        >
            <div class="dialog-card-container">
                <p class="dialog-card-container__title">
                    {{ getText('simulations_total') }}
                </p>
                <div class="wrap-container">
                    <span v-html="wrapSingleNumber(simulationsTotal)"></span>
                </div>
            </div>
        </el-card>
        <p class="repetition-text">
            {{ getText('simulations_repetition') }}
        </p>
        <div class="years-scroll">
            <div v-if="hasSimulations">
                <div
                    v-for="simulation in sortedSimulationUsages"
                    :key="simulation.uid"
                >
                    {{ simulation.year }}
                    <el-card
                        v-for="(monthIndex, index) in sortedMonths(simulation.monthly_counter)"
                        :key="index"
                        shadow="never"
                        class="monthly-card card-container__card"
                    >
                        <div class="monthly-card__container">
                            <div class="monthly-card__container__month">
                                {{ getMonthName(monthIndex) }} {{ simulation.year }}
                            </div>
                            <div class="round-history-button">
                                {{ simulation.monthly_counter[monthIndex] }}
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
            <div v-else>
                <em>{{ getText('no_simulation') }}</em>
            </div>
            <el-button
                class="close-btn greenButton"
                type="primary"
                @click="closeModal"
            >
                Fermer
            </el-button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {

    name: 'historyModal',

    props:{
        simulationUsages:{
            type: Array,
            required: true
        },
    },

    data () {
        return {

        };
    },

    computed: {
        ...mapGetters([
            'getText',
            'currentUser',
        ]),
        sortedSimulationUsages(){
          let usages = [...this.simulationUsages];
          return usages.sort((a, b) => b.year - a.year);
        },
        simulationsTotal() {
            let total = 0;
            this.simulationUsages.forEach(usage => {
                if (usage.monthly_counter) {
                    Object.values(usage.monthly_counter).forEach(value => {
                        if (typeof value === 'number' && !isNaN(value)) {
                            total += value;
                        }
                    });
                }
            });
            return total;
        },
        hasSimulations(){
            return this.simulationUsages.length > 0;
        }
    },

    methods:{
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        getMonthName(monthIndex) {
            let monthName = moment().month(parseInt(monthIndex) - 1).format('MMMM');
            return this.capitalize(monthName);
        },
        closeModal(){
            this.$emit('close');
        },
        wrapSingleNumber(number) {
            return number.toString().split('').map(digit => `<span class="wrap">${digit}</span>`).join('');
        },
        sortedMonths(months){
            return Object.keys(months).sort((a, b) => parseInt(b) - parseInt(a));
        }
    }
};
</script>

<style lang="scss">
.history-dialog{
    text-align: left;
    .el-dialog__title{
        margin: 0;
    }
}
.dialog-card-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__title{
        color: #27316E;
        font-weight: bold;
    }
}
.monthly-card{
    margin: 1rem 0;
    &__container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__month{
            color: black;
            font-weight: 500;
        }
    }
}
.repetition-text{
    font-weight: bold;
    color: black;
    margin: 2rem 0;
}
.wrap-container{
    padding: 1rem 0.5rem 1rem 1rem;;
    border-radius: 3px;
    background-color: #C4D600;
}
.wrap{
    background: white;
    margin-right: 0.5rem;
    color: #27316E;
    padding: 0.5rem;
    border-radius: 5px;
    font-weight: 600;
    font-size: 15px;
}
.round-history-button{
    border-radius: 2rem;
    background: #27316E;
    color: white;
    padding: 0.5rem;
}
.years-scroll {
    max-height: 500px;
    overflow-y: auto;
}
.close-btn{
    width: 100%;
    margin-top: 6rem;
}
.ns-loader{
    .total-card.el-card{
        min-height: 60px;
        .el-card__body{
            min-height: 60px;
        }
    }
    .monthly-card.el-card{
        min-height: 60px;
        .el-card__body{
            min-height: 60px;
        }
    }
}
.current-user-email{
    margin-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/historyModal.vue